import type { ButtonProps } from '@sravni/react-design-system/lib/Button';
import { useState } from 'react';

import { RESTRICTION_FLAGS } from 'constants/offer';

import type { TOffer } from 'shared/types/TRankingService';

import type { TPledgeAutoFields } from 'entities/pledgeAutoForm';

import { useSendOffer } from 'features/OfferControls';
import { OfferButton } from 'features/OfferControls/ui/OfferButton/OfferButton';
import { PledgeAutoPopup } from 'features/OfferControls/ui/PledgeAuto/PledgeAutoPopup';

import { OfferControlsTexts } from '../../OfferControls.texts';

interface ISendOfferProps {
  offer: TOffer;
  buttonProps?: ButtonProps;
}

export const PledgeAuto = ({ offer, buttonProps }: ISendOfferProps) => {
  const { onClick: onClickProp, ...otherButtonProps } = buttonProps || {};
  const { sendOffer, isLoading } = useSendOffer('PledgeAuto');
  const [isShowPopup, setIsShowPopup] = useState(false);
  const isRequiredCarNumber = offer?.additionalInfo?.restrictionFlags?.includes(RESTRICTION_FLAGS.WITH_CAR_NUMBER_ONLY);

  const onSubmit = async (data: TPledgeAutoFields) => {
    await sendOffer(offer, { pledgeAutoData: data });
    setIsShowPopup(false);
  };

  const onShowPopup = async () => {
    setIsShowPopup(true);
  };
  const onClosePopup = () => {
    setIsShowPopup(false);
  };

  return (
    <>
      <OfferButton
        {...otherButtonProps}
        variant="primary"
        color="dark"
        onClick={(event) => {
          event.stopPropagation();
          onShowPopup();
          onClickProp?.(event);
        }}
        loading={isLoading || isShowPopup}
      >
        {offer?.additionalInfo?.buttonText || OfferControlsTexts.sendOfferLabel}
      </OfferButton>
      <PledgeAutoPopup
        onSubmit={onSubmit}
        isSubmitting={isLoading}
        isShowPopup={isShowPopup}
        onClosePopup={onClosePopup}
        isRequiredCarNumber={isRequiredCarNumber}
      />
    </>
  );
};
